import React, { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Grid,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import Card from "../../../../components/Cards/Card";
import NativeObject from "../../../../components/NativeObject/NativeObject";
import LayoutWrapper from "../../../../components/LayoutWrapper/LayoutWrapper";
import { useSelections } from "../../../../context/Selections";

function InsightsGoldenDistribuicaoDesktop({ app, config }) {
  const { selections } = useSelections();
  const [selectedValue, setselectedValue] = useState("Alimentar");
  const [selectedValueSort, setselectedValueSort] = useState("Não Positivados");
  const [quantityGoldenStores, setQuantityGoldenStores] = useState();

  function handleChange(value) {
    app.field("Visao_AMB").selectMatch(value);
  }

  function handleChangeSort(value) {
    app.field("Visao_SORT").selectMatch(value);
  }

  const fetchTransformObjectValueInText = useCallback(
    async (objectId) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          setQuantityGoldenStores(value && value[0] !== "-" ? value : null);
        });
      }
    },
    [app, setQuantityGoldenStores]
  );

  useEffect(() => {
    if (app) {
      const visaoField = selections.find((s) => s.qField === "Visao_AMB");
      setselectedValue(visaoField?.qSelected);

      const visaoSort = selections.find((s) => s.qField === "Visao_SORT");
      setselectedValueSort(visaoSort?.qSelected);
      fetchTransformObjectValueInText("AtyDe");
    }
  }, [app, selections]);

  return (
    <div className="app DistribuicaoGoldenStores-insights">
      <div className="appContent">
        <LayoutWrapper>
          <Grid container width={"100%"}>
            <Grid className="container-line-one-insights">
              <span className="title-form"> Canal </span>
              <FormControl className="container-form-control">
                <RadioGroup
                  defaultValue="Alimentar"
                  row
                  name="row-radio-buttons-group"
                  className="radio-group radio-group-button-export"
                  value={selectedValue}
                  onChange={(e) => handleChange(e.target.value)}
                  sx={{ marginLeft: "20px" }}
                >
                  <FormControlLabel
                    value="Alimentar"
                    control={
                      <Radio
                        size="small"
                        defaultChecked
                        sx={{
                          color: "#55b6eb",
                          "&.Mui-checked": {
                            color: "#55b6eb",
                          },
                        }}
                      />
                    }
                    label="Alimentar"
                  />

                  <FormControlLabel
                    value="Farma"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#55b6eb",
                          "&.Mui-checked": {
                            color: "#55b6eb",
                          },
                        }}
                      />
                    }
                    label="Farma"
                  />

                  <FormControlLabel
                    value="Perfumaria"
                    control={
                      <Radio
                        size="small"
                        sx={{
                          color: "#55b6eb",
                          "&.Mui-checked": {
                            color: "#55b6eb",
                          },
                        }}
                      />
                    }
                    label="Perfumaria"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            <Grid width={"100%"}>
              <Grid className="line-one">
                <Grid className="container-part-one-line-one-distribuidores">
                  <Grid className="container-cards-distribuidores">
                    <Card
                      app={app}
                      header={{
                        hardTitle: `Itens  neste canal`,
                      }}
                      className={"container-numbers-card"}
                    >
                      <NativeObject
                        app={app}
                        key="327e307f-1b41-4ec1-8d1d-aa8cc8d4f227"
                        type={"table"}
                        reference={{
                          id: "327e307f-1b41-4ec1-8d1d-aa8cc8d4f227",
                        }}
                        className={"number-card"}
                        style={{
                          height: "47px",
                          width: "100%",
                        }}
                      />
                    </Card>

                    <Card
                      app={app}
                      header={{
                        hardTitle: "Golden Stores com 100%",
                      }}
                      className={"container-numbers-card"}
                    >
                      <NativeObject
                        app={app}
                        key="fsrwa"
                        type={"table"}
                        reference={{
                          id: "fsrwa",
                        }}
                        className={"number-card"}
                        style={{
                          height: "47px",
                          width: "100%",
                        }}
                      />
                    </Card>
                  </Grid>

                  <Grid className="container-table-sortimento">
                    <Card
                      app={app}
                      header={{
                        hardTitle: "Sortimento x Golden Stores",
                      }}
                      style={{ position: "relative" }}
                    >
                      <span className="text-golden">
                        Quantidade de Golden Stores: {quantityGoldenStores}
                      </span>

                      <NativeObject
                        app={app}
                        key="5b03bf4c-ff60-41fb-a418-3b6eab8293c3"
                        type={"table"}
                        reference={{
                          id: "5b03bf4c-ff60-41fb-a418-3b6eab8293c3",
                        }}
                        className={"table-sortimento"}
                        style={{
                          padding: "0",
                          height: "350px",

                          width: "100%",
                        }}
                      />
                    </Card>
                  </Grid>
                </Grid>

                <Grid width={"50%"} height={"100%"} className="card-mobile">
                  <Card
                    app={app}
                    header={{
                      hardTitle: "Oportunidades por Golden Stores",
                    }}
                    className="container-table-line-insight"
                    exportTable
                    exportTableId="mFBBqZ"
                  >
                    <NativeObject
                      app={app}
                      key="mFBBqZ"
                      type={"table"}
                      reference={{
                        id: "mFBBqZ",
                      }}
                      style={{
                        height: "579px",

                        width: "100%",
                      }}
                    />
                  </Card>
                </Grid>
              </Grid>
            </Grid>

            <Grid className="line-two" width={"100%"}>
              <Card
                app={app}
                header={{
                  hardTitle: "Análise por Sortimento",
                }}
                exportTable
                exportTableId="KnPFHP"
                exportContainer
              >
                <FormControl className="container-form-control">
                  <RadioGroup
                    defaultValue="Não positivados"
                    row
                    name="row-radio-buttons-group"
                    className="radio-group radio-group-button-export"
                    value={selectedValueSort}
                    onChange={(e) => handleChangeSort(e.target.value)}
                    sx={{ marginBottom: "10px" }}
                  >
                    <FormControlLabel
                      value="Não Positivados"
                      control={
                        <Radio
                          size="small"
                          defaultChecked
                          sx={{
                            color: "#55b6eb",
                            "&.Mui-checked": {
                              color: "#55b6eb",
                            },
                          }}
                        />
                      }
                      label="Não Positivados"
                    />

                    <FormControlLabel
                      value="Positivados"
                      control={
                        <Radio
                          size="small"
                          sx={{
                            color: "#55b6eb",
                            "&.Mui-checked": {
                              color: "#55b6eb",
                            },
                          }}
                        />
                      }
                      label="Positivados"
                    />
                  </RadioGroup>
                </FormControl>

                <NativeObject
                  app={app}
                  key="KnPFHP"
                  type={"table"}
                  reference={{
                    id: "KnPFHP",
                  }}
                  style={{
                    padding: "0",
                    height: "441px",
                    width: "100%",
                  }}
                />
              </Card>
            </Grid>
          </Grid>
        </LayoutWrapper>
      </div>
    </div>
  );
}

InsightsGoldenDistribuicaoDesktop.defaultProps = {
  app: null,
  config: {},
};

InsightsGoldenDistribuicaoDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default InsightsGoldenDistribuicaoDesktop;
